import { Dispatch } from "redux";
import { ACTION_TYPES } from "../constants/actionTypes";
import { ADMIN_TYPES } from "../constants/adminTypes";
import { getAdminSubscription, getAdminAnalytics } from "@api/user/admin";
import { saveUserTutorialStatus } from "@api/user/user";

/********************************************
  Update tutorial status action
*********************************************/
export const updateTutorialStatusAction =
  (data: any) => async (dispatch: Dispatch) => {
    // Dispatch a loading alert
    dispatch({
      type: ACTION_TYPES.ALERT,
      payload: { loading: true },
    });

    try {
      // Fetch response from server
      const res = await saveUserTutorialStatus(data);

      // Dispatch User tutorial status with the actual tutorial data
      dispatch({
        type: ADMIN_TYPES.UPDATE_TUTORIAL_STATUS,
        payload: data, // Pass the tutorial data, not res.data
      });

      // Dispatch a success/error sign up alert
      dispatch({
        type: ACTION_TYPES.ALERT,
        payload: { loading: false },
      });
    } catch (error) {
      // Dispatch a error alert
      dispatch({
        type: ACTION_TYPES.ALERT,
        payload: {
          message: "UPDATE_TUTORIAL_STATUS_ACTION_ERROR",
        },
      });
    }
  };

/********************************************
  Get admin subscription action
*********************************************/
export const getAdminSubscriptionAction =
  (setLoading: any) => async (dispatch: Dispatch) => {
    // Dispatch a loading alert
    dispatch({
      type: ACTION_TYPES.ALERT,
      payload: { loading: true },
    });

    try {
      // Fetch response from server
      const res = await getAdminSubscription();

      // Dispatch subscription
      dispatch({
        type: ADMIN_TYPES.GET_ADMIN_SUBSCRIPTION,
        payload: res.data,
      });

      // Dispatch a success/error sign up alert
      dispatch({
        type: ACTION_TYPES.ALERT,
        payload: { loading: false },
      });

      // Set loading to false
      setLoading(false);
    } catch (error) {
      setLoading(false);

      // Dispatch a error alert
      dispatch({
        type: ACTION_TYPES.ALERT,
        payload: {
          message: "GET_ADMIN_SUBSCRIPTION_ACTION_ERROR",
        },
      });
    }
  };

/********************************************
 * Get admin analytics action
 * ******************************************/
export const getAdminAnalyticsAction =
  (setLoading: any) => async (dispatch: Dispatch) => {
    // Dispatch a loading alert
    dispatch({
      type: ACTION_TYPES.ALERT,
      payload: { loading: true },
    });

    try {
      // Fetch response from server
      const res = await getAdminAnalytics();

      // Dispatch archives
      dispatch({
        type: ADMIN_TYPES.GET_ADMIN_ANALYTICS,
        payload: res.data,
      });

      // Dispatch a success/error sign up alert
      dispatch({
        type: ACTION_TYPES.ALERT,
        payload: { loading: false },
      });

      // Set loading to false
      setLoading(false);
    } catch (error) {
      // Dispatch a error alert
      dispatch({
        type: ACTION_TYPES.ALERT,
        payload: {
          message: "GET_ADMIN_ANALYTICS_ACTION_ERROR",
        },
      });
    }
  };
